import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-chiudi-ticket-backoffice',
  templateUrl: './chiudi-ticket-backoffice.component.html',
  styleUrls: ['./chiudi-ticket-backoffice.component.css']
})
export class ChiudiTicketBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;

  readonly #modal = inject(NzModalRef)
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onElimina() {
    this.loading = true;

    // Aggiorno lo stato del ticket
    this.apiService.updateStatoTicket(this.nzModalData.id_ticket!, 'Chiuso').subscribe({
      next: (data) => this.apiService.setTickets(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      }, complete: () => {
        this.loading = false;
        this.#modal.destroy(true);
      }
    })

  }
  
  onClose() {
    this.#modal.destroy(false);
  }
}
